module.exports = __webpack_public_path__ + "media/images/growth_mindset/title-page-description-5e1d8b55ab53ff48641c3154b232d1dc.png";